import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import WarningIcon from '@mui/icons-material/Warning';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

type ErrorModalPropOptions = {
  open: boolean;
  errorTitle: string;
  paragraphOne: ReactElement | string;
  paragraphTwo: ReactElement | string;
  handleOnClose: VoidFunction;
};

const ErrorModal = ({
  open,
  errorTitle,
  paragraphOne,
  paragraphTwo,
  handleOnClose,
}: ErrorModalPropOptions) => {
  useTranslation('launchSiteTypeModal');
  const { t } = useTranslation('error');

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <Grid container display="flex" alignItems="center">
          <Grid item>
            <WarningIcon color="error" />
          </Grid>
          <Grid item>
            <DialogTitle id="modal-modal-title" variant="h2" component="h2">
              {errorTitle}
            </DialogTitle>
          </Grid>
        </Grid>
        <Divider />
        <Grid container mt={2}>
          <Grid item>
            <Typography id="modal-modal-description" mb={2}>
              {paragraphOne}
            </Typography>
          </Grid>
        </Grid>
        <Grid container mt={2}>
          <Grid item>
            <Typography id="modal-modal-description">{paragraphTwo}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          data-testid="close-modal"
          onClick={handleOnClose}
        >
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorModal;
